/**
 * plugins/vuetify.js
 *
 * Vuetify 4 configuration and initialization.
 * Framework documentation: https://vuetifyjs.com
 *
 * Configures:
 * - VVideo (still a lab component, not yet in stable release)
 * - VIconBtn (promoted to core in Vuetify 4.1.0, imported from "vuetify/components")
 * - Material Design Icons (MDI) as the icon font
 * - Dark theme as the default theme
 */

import { VVideo } from "vuetify/labs/VVideo";
// VIconBtn graduated from labs to core in Vuetify 4.1.0
import { VIconBtn } from "vuetify/components";

// Styles - Material Design Icons CSS for icon support
import "@mdi/font/css/materialdesignicons.css";
// Vuetify's core styles (components, utilities, grid, etc.)
import "vuetify/styles";

// Composables
import { createVuetify } from "vuetify";

/**
 * Create and export the Vuetify instance with custom configuration.
 * - Registers VVideo (lab) and VIconBtn (core, 4.1.0+) globally
 * - Sets dark theme as the default for the entire application
 */
// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
export default createVuetify({
  components: {
    VIconBtn, // Core component (promoted from labs in 4.1.0): compact icon button
    VVideo,   // Lab component: video player wrapper
  },
  theme: {
    defaultTheme: "dark", // Use dark theme throughout the application
    themes: {
      dark: {
        colors: {
          // Custom theme color so `rgb(var(--v-theme-yellow))` resolves —
          // SwipeableListItem builds its action-panel background from theme
          // CSS vars, and the star swipe action uses "yellow". Material
          // yellow-darken-3: dark enough for the white glyph/label on top.
          yellow: "#F9A825",
        },
      },
    },
  },
});
